import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { isStaleChunkError, reloadForStaleChunk } from './app/core/stale-chunk/stale-chunk';

console.log('Application booted', new Date());

const supportedDocumentLanguages = new Set(['en', 'es', 'fr', 'de', 'it', 'ru']);

function applyInitialDocumentLanguage(): void {
  const browserLanguage = window.navigator.languages?.[0] ?? window.navigator.language;

  const language = browserLanguage.toLowerCase().split('-')[0];
  const documentLanguage = supportedDocumentLanguages.has(language) ? language : 'en';

  document.documentElement.lang = documentLanguage;
  document.documentElement.dir = ['ar', 'he', 'fa', 'ur'].includes(documentLanguage)
    ? 'rtl'
    : 'ltr';
}

if (typeof window !== 'undefined') {
  applyInitialDocumentLanguage();

  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled rejection:', event.reason);

    if (!isStaleChunkError(event.reason)) {
      return;
    }

    if (!reloadForStaleChunk()) {
      console.warn('Stale Angular chunk detected, but a reload was just attempted. Skipping another reload.');
    }
  });
}

bootstrapApplication(App, appConfig).catch((err) => {
  console.error('Angular bootstrap failed:', err);
});
